import { render, staticRenderFns } from "./fileinfo.vue?vue&type=template&id=34e8fcb2&scoped=true"
import script from "./fileinfo.vue?vue&type=script&lang=js"
export * from "./fileinfo.vue?vue&type=script&lang=js"
import style0 from "./fileinfo.vue?vue&type=style&index=0&id=34e8fcb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e8fcb2",
  null
  
)

export default component.exports